export default __webpack_public_path__ + "static/fonts/DidotHTF-Bold.c1a7ed0.woff2";